import uuidv4 from 'uuid/v4';
import store from '../store';

// Temporary gate for creating/funding agreements. No acknowledgement is saved
// in cookies or local storage; each action requires its own explicit decision.
export const CONTRACT_SECURITY_REVIEW_REQUIRED = true;

function transactionContext(state) {
  const { auth, agreement, menu } = state;
  return JSON.stringify([
    auth.status, auth.uuid, auth.username, auth.ethAddress, auth.ethNetwork, auth.testMode,
    menu.fullPath, menu.queryParams, menu.hash, agreement.agreementid, agreement.versionid,
    agreement.agreedSha3, agreement.agreedData, agreement.deployedid
  ]);
}

export function answerContractSecurityReview(id, continueAnyway) {
  return { type: 'ANSWER_CONTRACT_SECURITY_REVIEW', payload: { id, continueAnyway } };
}

function requestContractSecurityReview(dispatch, getState) {
  if (!CONTRACT_SECURITY_REVIEW_REQUIRED) return Promise.resolve(true);
  if (getState().contractSecurityReview.pendingId || getState().auth.metamaskOpened) {
    return Promise.resolve(false);
  }

  const id = uuidv4();
  const context = transactionContext(getState());
  return new Promise(resolve => {
    // Keep callbacks out of Redux and preserve the underlying deposit dialog's
    // state. Closing this notice never dispatches OPEN_OVERLAY/CLOSE_OVERLAY.
    const unsubscribe = store.subscribe(() => {
      const state = getState();
      if (transactionContext(state) !== context) {
        unsubscribe();
        dispatch(answerContractSecurityReview(id, false));
        resolve(false);
      } else if (state.contractSecurityReview.pendingId !== id) {
        unsubscribe();
        resolve(state.contractSecurityReview.approvedId === id);
      }
    });
    dispatch({ type: 'REQUEST_CONTRACT_SECURITY_REVIEW', payload: id });
  });
}

// The supplied thunk captures exactly the action the user initiated. An answer
// is consumed once; it never grants permission to subsequent transactions.
export function withContractSecurityReview(action) {
  return async function(dispatch, getState) {
    const context = transactionContext(getState());
    if (await requestContractSecurityReview(dispatch, getState)) {
      // Recheck after the promise settles in case another action changed the
      // wallet or agreement between the user's answer and this continuation.
      if (transactionContext(getState()) === context) return dispatch(action);
    }
    return false;
  };
}
